import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { SITE as SITE_FALLBACK } from "@/data/site";

// Default public settings used until the API responds (also as fallback on error).
const DEFAULTS = {
  business_name: "Unique Home Tutors",
  website_title: "Unique Home Tutors — Home Tuition, Coaching & Online Classes",
  tagline: "Excellence in 1:1 Education",
  footer_copyright: `© ${new Date().getFullYear()} Unique Home Tutors. All rights reserved.`,
  website_url: "https://uniquehometutors.com",
  support_email: SITE_FALLBACK.email,
  whatsapp_number: "+917000530316",
  ho_address: SITE_FALLBACK.jabalpur.address,
  ho_phone: SITE_FALLBACK.jabalpur.phone,
  branch_address: SITE_FALLBACK.nagpur.address,
  branch_phone: SITE_FALLBACK.nagpur.phone,
  show_footer_admin_login: false,
  social: {
    instagram: { url: SITE_FALLBACK.social.instagram, enabled: true },
    facebook: { url: SITE_FALLBACK.social.facebook, enabled: true },
    youtube: { url: SITE_FALLBACK.social.youtube, enabled: true },
    linkedin: { url: SITE_FALLBACK.social.linkedin, enabled: true },
    twitter: { url: "", enabled: false },
    telegram: { url: "", enabled: false },
    whatsapp: { url: `https://wa.me/${SITE_FALLBACK.jabalpur.whatsapp}`, enabled: true },
    gbp: { url: SITE_FALLBACK.jabalpur.gbp || "", enabled: true },
  },
};

const Ctx = createContext({ settings: DEFAULTS, loading: true });

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api.get("/settings/public")
      .then(({ data }) => {
        if (!alive) return;
        setSettings((p) => ({
          ...p,
          ...data,
          social: { ...p.social, ...(data.social || {}) },
        }));
      })
      .catch(() => { /* keep defaults */ })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  return <Ctx.Provider value={{ settings, loading }}>{children}</Ctx.Provider>;
}

export const useSiteSettings = () => useContext(Ctx).settings;
